import React, { useEffect, useState } from 'react';
import { DateInput } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { WrapToError } from '../../ContributionEmployeesSettings/ContributionEmployeesSettings.styles';
import WarnIconWithText from '../../ContributionEmployeesSettings/WarnIconWithText';
import { ChangedContributionRecord, useChangedContributionRecordsStore } from '../useChangedContributionRecords.store';

interface Props {
  record?: ChangedContributionRecord;
}

const ContributionDateInput: React.FC<Props> = ({ record }) => {
  const [isFocused, setIsFocused] = useState(false);
  const { changeRecord } = useChangedContributionRecordsStore();

  useEffect(() => () => setIsFocused(false), []);

  return (
    <WrapToError
      hasError={Boolean(record?.dateError)}
      width={{ min: '140px', max: '140px' }}
      onBlur={() => setIsFocused(false)}
      onFocus={() => setIsFocused(true)}
    >
      <DateInput
        disabled={record?.isDeleted}
        name="contributionDateOn"
        isPicker
        value={record?.contributionDateOn ? dayjs(record?.contributionDateOn).format(DEFAULT_DATE_FORMAT) : ''}
        onChange={(val) => {
          if (isFocused) {
            changeRecord({
              ...record,
              contributionDateOn: val,
            });
          }
        }}
        placeholder="Set date"
        {...(record?.dateError
          ? {
              rightIcon: <WarnIconWithText message={record?.dateError} />,
            }
          : {})}
      />
    </WrapToError>
  );
};

export default ContributionDateInput;
